import { useMutation } from '@tanstack/react-query';
import { api } from '@/lib/api/endpoints';
import type {
  DatasetQueryRequest,
  DatasetQueryResponse,
} from '@/features/datasets/types/query.types';

export const useDatasetQuery = (datasetId: string) => {
  return useMutation<DatasetQueryResponse, unknown, DatasetQueryRequest>({
    mutationFn: async (request: DatasetQueryRequest) => {
      const response = await api.datasets.query(datasetId, request);
      return response.data as DatasetQueryResponse;
    },
  });
};
